import { useBeneficiaryOwners } from '~/modules/identification/forms/TaxResidencyAdditionalInformation/hooks/useBeneficiaryOwners.ts';
import { useMemo } from 'react';
import { USA_CODE } from '~/constants/common.ts';
import { TOwner } from '~/modules/identification/forms/OwnershipStructure/types.ts';

const parsePercentage = (value: unknown): number | null => {
  if (value === null || value === undefined || value === '') return null;
  const n = Number(String(value).replace(',', '.'));
  return Number.isNaN(n) ? null : n;
};

const isUSOwnerWith10Percent = (owner: TOwner) => {
  const percentage = parsePercentage(owner.ownershipPercentage);

  const isUS = [
    owner.birthplaceCountry?.value,
    owner.citizenshipCountry?.value,
    owner.residenceCountry?.value,
    owner.address?.registrationAddress?.country?.value,
    owner.address?.permanentAddress?.country?.value,
  ].includes(USA_CODE);

  return isUS && (percentage === null || percentage >= 10);
};

export const useFilterBeneficiaryOwners = () => {
  const { beneficiaryOwners, individualOwners } = useBeneficiaryOwners();

  const beneficiaryUSA = useMemo(
    () => (beneficiaryOwners || []).filter(isUSOwnerWith10Percent),
    [beneficiaryOwners]
  );

  const individualOwners10 = useMemo(() => {
    const beneficiaryIds = new Set(beneficiaryUSA.map((o) => o.id));

    return (individualOwners || []).filter(
      (owner) => isUSOwnerWith10Percent(owner) && !beneficiaryIds.has(owner.id)
    );
  }, [individualOwners, beneficiaryUSA]);

  const combinedOwners = useMemo(
    () => [...beneficiaryUSA, ...individualOwners10],
    [beneficiaryUSA, individualOwners10]
  );

  return { beneficiaryUSA, individualOwners10, combinedOwners };
};
